import React, { useEffect } from 'react';

import './FabulaUltimaGamePanel.css';
import { CreatureObject } from '@common/FabulaUltimaGame';
import type { Api } from '@common/FabulaUltimaGame';
import { CommandHistoryButton, type StateTimelineItem } from '../CommandHistoryButton';
import { CommandPalette } from '../CommandPalette';
import { CreatureCard } from '../CreatureCard/CreatureCard';
import { GameStateButton } from '../GameStateButton/GameStateButton';
import type { FuLocale } from '../../i18n/fuLocale';
import { formatFabulaUltimaCommandForDisplay } from '@common/FabulaUltimaCommand';

const kHeartbeatIntervalMs = 60 * 1000;   // 1 minute

interface FabulaUltimaGamePanelProps {
  characters: CreatureObject[];
  enemies: CreatureObject[];
  onGenCommand: (query: string) => Promise<string>;
  onRunCommands: (commands: string[]) => void;
  onUploadGameState: (req: Api.UploadGameStateRequest) => void;
  onHeartbeat: () => void;
  isHost: boolean;
  stateTimeline: StateTimelineItem[];
  stateTimelinePosition: number;
  onMoveStateTimeline: (position: number) => void;
  onRollbackStateTimeline: (position: number) => void;
  commandHistory: Api.UploadGameStateCommandHistory[];
  buffHistory: string[];
  locale: FuLocale;
}

export const FabulaUltimaGamePanel: React.FC<FabulaUltimaGamePanelProps> = ({
  characters,
  enemies,
  onGenCommand,
  onRunCommands,
  onUploadGameState,
  onHeartbeat,
  isHost,
  stateTimeline,
  stateTimelinePosition,
  onMoveStateTimeline,
  onRollbackStateTimeline,
  commandHistory,
  buffHistory,
  locale,
}) => {
  const canEdit = stateTimelinePosition === stateTimeline.length;
  const handleGenCommand = (query: string) => {
    console.log("handleGenCommand", query);
    return onGenCommand(query);
  };
  const handleRunCommands = (commands: string[]) => {
    console.log("handleRunCommands", commands.map(formatFabulaUltimaCommandForDisplay));
    onRunCommands(commands);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      onHeartbeat();
    }, kHeartbeatIntervalMs);
    return () => clearInterval(interval);
  }, [onHeartbeat]);

  return (
    <div className="game-panel">
      <div className="fu-battlefield-scroll">
      <div className="battlefield-section">
        <div className="characters-section">
          <h2>我方角色</h2>
          <div className="creatures-list">
            {characters.map(character => (
              <CreatureCard key={character.name} creature={character} isHost={isHost} canEdit={canEdit} onRunCommands={onRunCommands} buffHistory={buffHistory} locale={locale} />
            ))}
          </div>
        </div>
        <div className="enemies-section">
          <h2>敌方单位</h2>
          <div className="creatures-list">
            {enemies.map(enemy => (
              <CreatureCard key={enemy.name} creature={enemy} isHost={isHost} canEdit={canEdit} onRunCommands={onRunCommands} buffHistory={buffHistory} locale={locale} />
            ))}
          </div>
        </div>
      </div>
      </div>
      <div className="fu-command-dock">
      <CommandPalette onGenCommand={handleGenCommand} onCommands={handleRunCommands}
        existingNames={[...characters, ...enemies].map(creature => creature.name)}
        canEdit={canEdit} isHost={isHost} locale={locale} />
      <CommandHistoryButton stateTimeline={stateTimeline} position={stateTimelinePosition} onMove={onMoveStateTimeline} onRollback={onRollbackStateTimeline} isHost={isHost} locale={locale} />
      <GameStateButton
        characters={characters}
        enemies={enemies}
        commandHistory={commandHistory}
        onUploadGameState={onUploadGameState}
        canUpload={isHost}
      />
      </div>
    </div>
  );
};
